import React, { memo, useEffect, useState } from 'react';

import { Marker} from 'react-map-gl';

const testAreEquals = (prevProps, nextProps) => {
  if (prevProps.feature !== nextProps.feature) {
    return false;
  }
  if (prevProps.layer_id !== nextProps.layer_id) {
    return false;
  }
  return true;
};


const FeaturePointSelected = ({feature, layer_id}) => {

  const [coordinates, setCoordinates] = useState([]);

  useEffect(() => {
    if (feature !== null && feature.geometry.type === 'MultiPoint') {
      setCoordinates(feature.geometry.coordinates[0]);
    } else if (feature !== null) {
      setCoordinates(feature.geometry.coordinates);
    } else {
      setCoordinates([]);
    }
    return () => {
      setCoordinates([]);
    };
  }, [feature, layer_id]);

  return (
    <>
      {
        coordinates.length > 0 &&
        <Marker anchor="center" scale={1.3} longitude={coordinates[0]} latitude={coordinates[1]}>
        </Marker>
      }
    </>
  );
};

export const FeaturePoint = memo(FeaturePointSelected, testAreEquals);